module.exports = __webpack_public_path__ + "img/6.cleaned_stainless_steel.72625950.svg";